export default __webpack_public_path__ + "static/media/I Hate CQC.cd6e6bcb.png";